import React, { memo } from 'react';
import { func, number, arrayOf, any } from 'prop-types';
import Radium from 'radium';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { List } from 'react-virtualized';
import 'react-virtualized/styles.css';
import { howLongSince } from '@widergy/web-utils/lib/date';
import { connect } from 'react-redux';
import { multilineEllipsis } from '@widergy/web-utils/lib/string';
import { UTLabel } from '@widergy/energy-ui';

import { actionCreators as alertActions } from 'redux/alertHandlers';
import { ROUTES } from 'constants/routes';

import UTTouchableWithoutFeedback from '../UTTouchableWithoutFeedback';
import icAlertNotificationItem from '../Topbar/assets/ic_modal_notification_on.png';
import { CLAIM, BILL, NOT_SEEN, READ } from '../../../constants/common';

import { MAX_STRING } from './constants';
import styles from './styles';

const retrieveLink = notification => {
  let link;
  if (notification.form_type) {
    link = notification.form_type === CLAIM ? ROUTES.CLAIMS : ROUTES.PROCEDURES;
  }
  if (notification.notification_type === BILL) link = ROUTES.BILLS;
  return link;
};

const today = moment();

const UTNotificationList = ({ onClick, rows, height, width, onRowsRendered, dispatch }) => {
  // eslint-disable-next-line react/prop-types
  const rowRenderer = ({ key, index, style }) => {
    const handleOnClick = () => {
      dispatch(alertActions.openModal({ content: rows[index].body }));
      onClick(rows[index].id);
    };
    const subText = howLongSince(rows[index].created_at, today);
    const link = retrieveLink(rows[index]);

    const container = rows[index].status !== READ ? styles.active : styles.inactive;
    const firstItem = index === 0 && styles.firstItem;
    const lastItem = index === rows.length - 1 && styles.lastItem;
    const newBody = multilineEllipsis(rows[index].body, MAX_STRING);
    return (
      <UTTouchableWithoutFeedback
        key={key}
        style={{ ...style, ...container, ...firstItem, ...lastItem }}
        onClick={handleOnClick}
      >
        {link ? (
          <Link to={link} style={styles.itemTitle}>
            {rows[index].body}
          </Link>
        ) : (
          <UTLabel translucentBlack style={styles.body}>
            {newBody}
          </UTLabel>
        )}
        <div style={styles.item}>
          {rows[index].status === NOT_SEEN && (
            <img src={icAlertNotificationItem} alt="icAlertNotification" style={styles.unreadIndicator} />
          )}
          {subText && (
            <UTLabel darkGray small>
              {subText}
            </UTLabel>
          )}
        </div>
      </UTTouchableWithoutFeedback>
    );
  };

  return (
    <List
      onRowsRendered={onRowsRendered}
      height={height}
      rowCount={rows.length}
      rowHeight={100}
      rowRenderer={rowRenderer}
      width={width}
    />
  );
};

UTNotificationList.propTypes = {
  onClick: func,
  rows: arrayOf(any), // eslint-disable-line react/forbid-prop-types
  height: number,
  width: number,
  onRowsRendered: func
};

export default connect()(memo(Radium(UTNotificationList)));
